import reducer from './profile';
import { actionCreators, ProfileActionType } from './profile.actionCreators';
import * as actionTypes from './profile.actionTypes';

export * from './profile';
export * from './profile.selectors';
export type ActionType = ProfileActionType;
export { actionTypes, actionCreators };
export default reducer;
